module.exports = __webpack_public_path__ + "static/media/icon-sms.238c8a2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-sms.svg
// module id = ./src/assets/images/icon-sms.svg
// module chunks = 6